import React, { useEffect, useState } from 'react';
import styles from './ConfirmRegistrationPage.module.css';
import Header from '../../components/Header/Header';
import { Row, Spinner } from "react-bootstrap";
import * as apiSupplierOnboard from '../../apis/supplierOnboard';
import confirmationLogo from '../../icons/confirmation-success.svg';

const ConfirmRegistrationPage = () => {
    const [supplierOnboard, setSupplierOnboard] = useState();
    const [isLoading, setIsLoading] = useState();

    useEffect(() => {
        let subs = window.location.pathname.split("/");
        
        const fetchData = async () => {
            setIsLoading(true);
            const supplierOnboardPromise = apiSupplierOnboard.getByRegistrationCode({registrationCode: subs.pop()});
            const [supplierOnboardResponse] = await Promise.all([
                supplierOnboardPromise,
            ]);
            setSupplierOnboard(supplierOnboardResponse.data.data);
            setIsLoading(false);
        }
        fetchData().catch(console.error);
    }, [])

    const copyRegistrationCode = async () => {
        const copied = await navigator.clipboard.writeText(supplierOnboard.registrationCode)
            .then(() => {
                alert("Kode registrasi " + supplierOnboard.registrationCode + " berhasil disalin.")})
            .catch(() => {
                alert("Error");
             });
        console.log(copied);
    }

    return <div className={styles.container}>
        <Header activeKey="/" />
        <div className={styles.pageBody}>
            {isLoading && 
                <Spinner className="mx-auto d-block"
                animation="border" size="lg" />
            }
            {supplierOnboard && !isLoading &&
            <Row>
                <div className={styles.confirmationCard}>
                    <div className={styles.iconArea}>
                        <img src={confirmationLogo}
                            alt={"Success"}
                            className={styles.iconImage}
                        />
                    </div>
                    <Row className='mt-4 justify-content-center'>
                        <div className={styles.textArea}>
                            <p>Pendaftaran berhasil! Mohon menunggu, tim kami akan melakukan verifikasi dalam waktu sekitar 7 hari kerja.</p>
                            <p><strong>Gunakan kode registrasi terlampir untuk lihat hasil verifikasi di halaman Cek Status.</strong></p>
                        </div>
                    </Row>
                    <Row className='mt-4 justify-content-center'>
                        <div className={styles.registrationCodeTextArea}>
                            <p className='m-0'>Kode Registrasi: <strong>{supplierOnboard.registrationCode}</strong></p>
                            <button onClick={() => {copyRegistrationCode()}} className='m-0'>Salin Kode</button>        
                        </div>
                    </Row>
                    <Row className='mt-4 justify-content-center'>
                        <div className={styles.textArea}>
                            <p>Jika ada pertanyaan terkait proses registrasi silakan menghubungi kami melalu email <a href="mailto:handoyo@segari.id">handoyo@segari.id</a></p>
                        </div>
                    </Row>
                </div>
            </Row>
            }
            {!supplierOnboard && !isLoading &&
            <Row>
                <div className={[styles.confirmationCard, styles.textArea]}>
                    <p>Data supplier tidak ditemukan!</p>
                </div>
            </Row>
            }
        </div>
    </div>
}

export default ConfirmRegistrationPage;